import React, {Component} from "react";
import ArrowLogoLeftIcon from "../../components/icons/ArrowLogoLeftIcon";
import ArrowRolloverLogoLeftIcon from "../../components/icons/ArrowRolloverLogoleftIcon";

export class LeftArrow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isHover: false
        };
    }

    onMouseEnterHandler() {
        this.setState({
            isHover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            isHover: false
        });
    }

    render() {
        return (
            <div onMouseEnter={() => this.onMouseEnterHandler()}
                 onMouseLeave={() => this.onMouseLeaveHandler()}
                 className="Left-Arrow-Container">
                {
                    this.state.isHover
                        ? <ArrowRolloverLogoLeftIcon/>
                        : <ArrowLogoLeftIcon/>
                }
            </div>
        );
    }
}